import React from "react";
type PianoKeysProps = {
  octaves?: number;
  className?: string;
};

// Touches noires qui suivent chaque touche blanche dans une octave (Do Ré Mi Fa Sol La Si)
const BLACK_AFTER = [true, true, false, true, true, true, false];
export function PianoKeys({
  octaves = 3,
  className = "h-12"
}: PianoKeysProps) {
  const whites = Array.from({
    length: octaves * 7
  }, (_, i) => i);
  return <div className={`flex w-full border-t-4 border-walnut ${className}`} aria-hidden="true" data-id="element-198" data-mp="u9dzv93lymim">
      {whites.map(i => {
      const hasBlack = BLACK_AFTER[i % 7] && i !== whites.length - 1;
      return <div key={i} className="relative flex-1 border-r border-ebony/15 bg-linen last:border-r-0" data-id="element-199" data-mp="13yffgy68r1w2">
            {hasBlack && <span className="absolute -right-[30%] top-0 z-10 h-[62%] w-[60%] rounded-b-sm bg-ebony" data-id="element-200" data-mp="1czdltn45jlht" />}
          </div>;
    })}
    </div>;
}